const ellipsis = {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
};
export const MuiListItemText = {
    styleOverrides: {
        root: {
            "&.MuiListItemText-multiline": {
                marginTop: "4px",
                marginBottom: "4px"
            }
        },
        primary: Object.assign({}, ellipsis),
        secondary: Object.assign({}, ellipsis)
    }
};
//# sourceMappingURL=ListItemText.js.map